import { useEffect, useRef, useState } from 'react'
import { Provider, createStore } from 'jotai'
import ProductSteps from './home'

export default function ProductStepsPage() {
  const store = createStore();
  return (
    <Provider store={store}>
      <ProductSteps></ProductSteps>
    </Provider>
  )
}
